import { Select } from "antd"
import React, { useEffect, useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap"
import Swal from "sweetalert2"

const LocationModal = ({
  isOpen,
  toggle,
  locationData,
  setlocationData,
  onChange,
  onSave,
  type = "",
  services,
  sageOptions,
}) => {
  const [errors, setErrors] = useState({})

  useEffect(() => {
    setErrors({})
  }, [isOpen])

  const validateForm = () => {
    const newErrors = {}

    if (!locationData?.name?.trim()) {
      newErrors.name = "Location name is required"
    }

    if (locationData?.type.length === 0) {
      newErrors.type = "Location Service Type is required"
    }

    if (!locationData?.address?.trim()) {
      newErrors.address = "Address is required"
    }

    if (!locationData?.contactPerson?.trim()) {
      newErrors.contactPerson = "Contact Person name is required"
    }

    if (!locationData?.contactNumber?.trim()) {
      newErrors.contactNumber = "Contact Number is required"
    }
    if (!locationData?.contactEmail?.trim()) {
      newErrors.contactEmail = "Contact Email is required"
    }

    if (!locationData?.city?.trim()) {
      newErrors.city = "City is required"
    }

    if (!locationData?.postalCode?.trim()) {
      newErrors.postalCode = "Postal Code is required"
    }

    if (!locationData?.mapLink?.trim()) {
      newErrors.mapLink = "Google Map link is required"
    } else if (!isValidUrl(locationData.mapLink)) {
      newErrors.mapLink = "Please enter a valid URL (e.g., https://...)"
    }

    if (
      !locationData?.employeePrice ||
      isNaN(locationData.employeePrice) ||
      Number(locationData.employeePrice) <= 0
    ) {
      newErrors.employeePrice = "Employee price must be a positive number"
    }

    let selectedServices = []
    try {
      selectedServices = locationData?.services
        ? JSON.parse(locationData.services)
        : []
    } catch (e) {
      selectedServices = []
    }

    if (!Array.isArray(selectedServices) || selectedServices.length === 0) {
      newErrors.services = "Please select at least one service"
    }

    if (!locationData?.startDate) {
      newErrors.startDate = "Start date is required"
    }

    if (!locationData?.endDate) {
      newErrors.endDate = "End date is required"
    } else if (
      locationData?.startDate &&
      locationData?.endDate < locationData?.startDate
    ) {
      newErrors.endDate = "End date must be on or after start date"
    }

    if (!locationData?.leaveSlot) {
      newErrors.leaveSlot = "No of Leave Slot is Required"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const isValidUrl = string => {
    try {
      new URL(string)
      return true
    } catch (_) {
      return false
    }
  }

  const handleSave = () => {
    if (!validateForm()) {
      return
    }

    // All valid → proceed with save
    onSave()
  }

  // Parse services for AntD Select
  const getSelectedServices = () => {
    try {
      return locationData?.services ? JSON.parse(locationData.services) : []
    } catch {
      return []
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xl">
      <ModalHeader toggle={toggle}>
        {type === "view"
          ? "View Location"
          : locationData?.id
          ? "Edit Location"
          : "Add Location"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col xl={4}>
              <FormGroup>
                <Label for="name">
                  Location Name <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  name="name"
                  value={locationData?.name || ""}
                  onChange={onChange}
                  disabled={type === "view"}
                  placeholder="Enter location name"
                  invalid={!!errors.name}
                />
                {errors.name && (
                  <div className="text-danger small mt-1">{errors.name}</div>
                )}
              </FormGroup>
            </Col>
            <Col xl={4}>
              <FormGroup>
                <Label for="name">
                  Location Service Type <span className="text-danger">*</span>
                </Label>
                <Select
                  mode="multiple"
                  allowClear
                  value={locationData?.type || []}
                  onChange={value =>
                    setlocationData({ ...locationData, type: value })
                  }
                  placeholder="Select Location Service Type"
                  style={{ width: "100%" }}
                >
                  <Select.Option value="window_cleaning">
                    Window Cleaning
                  </Select.Option>
                  <Select.Option value="industrial_cleaning">
                    Industrial Cleaning
                  </Select.Option>
                </Select>

                {errors.type && (
                  <div className="text-danger small mt-1">{errors.type}</div>
                )}
              </FormGroup>
            </Col>
            <Col xl={4}>
              <FormGroup>
                <Label for="sageContactId">Sage Account</Label>
                <Select
                  showSearch // enables search
                  optionFilterProp="children" // tells which prop to filter on
                  value={locationData?.sageContactId || undefined}
                  onChange={value =>
                    setlocationData({ ...locationData, sageContactId: value })
                  }
                  disabled={type !== "add"}
                  placeholder="Select Sage Account"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  style={{ width: "100%" }}
                >
                  {sageOptions?.map(item => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col xl={4}>
              <FormGroup>
                <Label for="name">
                  Contact Person <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  name="contactPerson"
                  value={locationData?.contactPerson || ""}
                  onChange={onChange}
                  disabled={type === "view"}
                  placeholder="Enter Contact Person name"
                  invalid={!!errors.contactPerson}
                />
                {errors.contactPerson && (
                  <div className="text-danger small mt-1">
                    {errors.contactPerson}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col xl={4}>
              <FormGroup>
                <Label for="name">
                  Contact Email <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  name="contactEmail"
                  value={locationData?.contactEmail || ""}
                  onChange={onChange}
                  disabled={type === "view"}
                  placeholder="Enter Contact Email"
                  invalid={!!errors.contactEmail}
                />
                {errors.contactEmail && (
                  <div className="text-danger small mt-1">
                    {errors.contactEmail}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col xl={4}>
              <FormGroup>
                <Label for="name">
                  Contact Number <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  name="contactNumber"
                  value={locationData?.contactNumber || ""}
                  onChange={e => {
                    const value = e.target.value

                    // Allow only numbers
                    if (/^\d*$/.test(value)) {
                      onChange(e)
                    }
                  }}
                  disabled={type === "view"}
                  placeholder="Enter Contact Number"
                  invalid={!!errors.contactNumber}
                />
                {errors.contactNumber && (
                  <div className="text-danger small mt-1">
                    {errors.contactNumber}
                  </div>
                )}
              </FormGroup>
            </Col>

            <Col xl={4}>
              <FormGroup>
                <Label for="name">
                  Leaves (No of Slots) <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  name="leaveSlot"
                  value={locationData?.leaveSlot || ""}
                  onChange={e => {
                    const value = e.target.value

                    // Allow only numbers
                    if (/^\d*$/.test(value)) {
                      onChange(e)
                    }
                  }}
                  disabled={type === "view"}
                  placeholder="Enter No of Leave Slots"
                  invalid={!!errors.leaveSlot}
                />
                {errors.leaveSlot && (
                  <div className="text-danger small mt-1">
                    {errors.leaveSlot}
                  </div>
                )}
              </FormGroup>
            </Col>
          </Row>

          <FormGroup>
            <Label for="address">
              Location Address <span className="text-danger">*</span>
            </Label>
            <Input
              type="textarea"
              name="address"
              rows="3"
              value={locationData?.address || ""}
              onChange={onChange}
              disabled={type === "view"}
              placeholder="Enter full address"
              invalid={!!errors.address}
            />
            {errors.address && (
              <div className="text-danger small mt-1">{errors.address}</div>
            )}
          </FormGroup>

          <Row>
            <Col xl={6}>
              <FormGroup>
                <Label for="name">
                  City <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  name="city"
                  value={locationData?.city || ""}
                  onChange={onChange}
                  disabled={type === "view"}
                  placeholder="Enter City"
                  invalid={!!errors.city}
                />
                {errors.city && (
                  <div className="text-danger small mt-1">{errors.city}</div>
                )}
              </FormGroup>
            </Col>
            <Col xl={6}>
              <FormGroup>
                <Label for="name">
                  Postal Code <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  name="postalCode"
                  value={locationData?.postalCode || ""}
                  onChange={onChange}
                  disabled={type === "view"}
                  placeholder="Enter Postal Code"
                  invalid={!!errors.postalCode}
                />
                {errors.postalCode && (
                  <div className="text-danger small mt-1">
                    {errors.postalCode}
                  </div>
                )}
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="mapLink">
                  Google Map Link <span className="text-danger">*</span>
                </Label>
                <Input
                  type="url"
                  name="mapLink"
                  value={locationData?.mapLink || ""}
                  onChange={onChange}
                  disabled={type === "view"}
                  placeholder="https://maps.google.com/..."
                  invalid={!!errors.mapLink}
                />
                {errors.mapLink && (
                  <div className="text-danger small mt-1">{errors.mapLink}</div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Services <span className="text-danger">*</span>
                </Label>
                <Select
                  mode="multiple"
                  style={{ width: "100%" }}
                  disabled={type === "view"}
                  placeholder="Select one or more services"
                  value={getSelectedServices()}
                  onChange={values =>
                    setlocationData({
                      ...locationData,
                      services: JSON.stringify(values),
                    })
                  }
                  options={services
                    ?.filter(srv =>
                      locationData?.type?.length
                        ? locationData.type.includes(srv.type)
                        : true
                    )
                    .map(srv => ({
                      label: srv?.name,
                      value: srv.id,
                    }))}
                  status={errors.services ? "error" : ""}
                />
                {errors.services && (
                  <div className="text-danger small mt-1">
                    {errors.services}
                  </div>
                )}
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <FormGroup>
                <Label>
                  Location Price for Employee (£){" "}
                  <span className="text-danger">*</span>
                </Label>
                <Input
                  type="number"
                  name="employeePrice"
                  min="0"
                  step="0.01"
                  value={locationData?.employeePrice || ""}
                  onChange={onChange}
                  disabled={type === "view"}
                  placeholder="e.g., 15.50"
                  invalid={!!errors.employeePrice}
                />
                {errors.employeePrice && (
                  <div className="text-danger small mt-1">
                    {errors.employeePrice}
                  </div>
                )}
              </FormGroup>
            </Col>

            <Col md={4}>
              <FormGroup>
                <Label>
                  Start Date <span className="text-danger">*</span>
                </Label>
                <Input
                  type="date"
                  name="startDate"
                  value={locationData?.startDate || ""}
                  onChange={onChange}
                  disabled={type === "view"}
                  invalid={!!errors.startDate}
                />
                {errors.startDate && (
                  <div className="text-danger small mt-1">
                    {errors.startDate}
                  </div>
                )}
              </FormGroup>
            </Col>

            <Col md={4}>
              <FormGroup>
                <Label>
                  End Date <span className="text-danger">*</span>
                </Label>
                <Input
                  type="date"
                  name="endDate"
                  value={locationData?.endDate || ""}
                  onChange={onChange}
                  disabled={type === "view"}
                  min={locationData?.startDate || undefined}
                  invalid={!!errors.endDate}
                />
                {errors.endDate && (
                  <div className="text-danger small mt-1">{errors.endDate}</div>
                )}
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>

      {type !== "view" && (
        <ModalFooter>
          <Button className="btn-blue" onClick={handleSave}>
            {locationData?.id ? "Update" : "Save"}
          </Button>
          <Button className="btn-cancel" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      )}
    </Modal>
  )
}

export default LocationModal
